import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";

const SUFFIX = "The Surrender Church";
const TITLES = {
  "/": "The Surrender Church | Abundant Life No. 2 · Brunswick, GA",
  "/about": `About Pastor Shalonda Raymond | ${SUFFIX}`,
  "/services": `Services, Prayer & Veteran Housing | ${SUFFIX}`,
  "/booking": `Book Pastor Shalonda | ${SUFFIX}`,
  "/blueprint": `Next Step Blueprint™ & Store | ${SUFFIX}`,
  "/give": `Give & Tithe Online | ${SUFFIX}`,
  "/dashboard": `Admin Dashboard | ${SUFFIX}`,
};

export default function Layout({ children }) {
  const { pathname } = useLocation();
  useEffect(() => { document.title = TITLES[pathname] || TITLES["/"]; }, [pathname]);
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1 pt-20">{children}</main>
      <Footer />
    </div>
  );
}
